import { Box, Typography } from '@mui/material';

import { OrganizationsDetails } from '@verantos-dev/data-access-organizations';
import { ApiWorkflowDialog, TransferList } from '@verantos-dev/shared-components';

import { useAssignmentDialog } from '../hooks/useAssignmentDialog';

type PropsType = {
  data: OrganizationsDetails;
};

export const AssignmentDialog = (props: PropsType) => {
  const { data: organizationData } = props;

  const {
    dialogHeader,
    leftTitle,
    rightTitle,
    isLoading,
    leftItem,
    rightItem,
    isUpdateAssignmentLoading,
    updateAssignmentError,
    description,
    dialogSubHeader,
    dialogSaveButton,
    dialogConfirmButton,
    dialogSubmittingSaveButton,
    isValidToSubmit,
    successText,
    onClose,
    onChange,
    onSubmit,
    confirmationStep,
  } = useAssignmentDialog(organizationData.organizationId);

  return (
    <ApiWorkflowDialog
      id="useAssignmentDialog"
      title={dialogHeader}
      size="large"
      isValidForSubmit={isValidToSubmit}
      isInitialLoading={isLoading}
      onClose={onClose}
      onSubmit={onSubmit}
      closeAfterTransition={false}
      isSubmitting={isUpdateAssignmentLoading}
      saveButtonColor="primary"
      submittingError={updateAssignmentError}
      dialogMessages={{
        entrySaveButtonText: dialogSaveButton,
        loadingSaveButtonText: dialogSaveButton,
        confirmationSaveButtonText: dialogConfirmButton,
        submittingSaveButtonText: dialogSubmittingSaveButton,
        successText: successText,
      }}
      renderSubmitting={confirmationStep()}
      renderConfirmationStep={confirmationStep()}
      hideDisplayButtonsOnSuccess
    >
      <Typography gutterBottom color="textSecondary">
        {description}
      </Typography>
      <Box key={`${leftItem.length}-${rightItem.length}`} sx={{ paddingTop: '5px' }}>
        <Typography gutterBottom color="textPrimary" fontWeight={'500'}>
          {dialogSubHeader}
        </Typography>
        <TransferList
          id="organization-dataset-transfer-list"
          leftTitle={leftTitle}
          rightTitle={rightTitle}
          leftItems={leftItem}
          rightItems={rightItem}
          onChange={onChange}
        />
      </Box>
    </ApiWorkflowDialog>
  );
};

export default AssignmentDialog;
